module.exports = __webpack_public_path__ + "sort-up.png?381068046f94affb5c0a1138a26b6d77";